import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { useTranslations } from 'use-intl';
import { identityKeys } from '@/lib/queries/identity';
import { SettingsErrorShell } from '@/components/settings/SettingsErrorShell';
import { EmailClient } from './-components/EmailClient';

export const Route = createFileRoute('/_authed/settings/email/')({
  component: SettingsEmailPage,
});

function SettingsEmailPage() {
  const t = useTranslations('Settings');
  const query = useQuery({
    ...identityKeys.privacy(),
    retry: false,
  });
  if (query.isError) {
    return (
      <SettingsErrorShell
        title={t('email.errorTitle')}
        message={t('email.loadError')}
      />
    );
  }
  if (query.isLoading) return null;
  return <EmailClient />;
}
